import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uiChangeSkladName } from '../../../actions/ui';
import WarehouseCommonApi from '../../../API/warehouse/common-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { SKLADS_WAREHOUSE, TYPE_BUTTONS } from '../../../constans';
import DeleteProductPopUp from './deleteProduct';
import ProductsTableLine from './ProductsTableLine';
import styles from './styles.module.scss';

const width = ['90px', '400px', '120px', '190px', '250px', '110px', '110px', '400px', '300px', '150px'];
//const B_WHITE_PRODUCT_LINK = slug => `https://b-white.ru/products/${slug}`;

const FILTER = {
  0: 'all',
  1: 'instock',
  2: 'nullstock',
  3: 'reserve',
  4: 'notmarker',
  5: 'notIp',
  6: 'old_products',
};

const FILTER_INVENTORY = {
  0: 'all',
  1: 'instock',
  2: 'matched',
  3: 'notMatched',
  4: 'notIp',
};

function WarehouseProductsPage() {
  const [search, setSearch] = useState('');
  const [limit, setLimit] = useState(50);
  const [remove, setRemove] = useState({ open: false, id: null });

  const [byId, setById] = useState({});
  const [ids, setIds] = useState([]);
  const [provider, changeProvider] = useState({ name: '', id: null });
  const [address, changeAddress] = useState('');
  const [isInventory, setIsInventory] = useState(false);

  const [providers, setProviders] = useState([]);
  const allProviders = useSelector((store) => store.providers);
  const [numDays, setNumDays] = useState(7);
  const [count, setCount] = useState(0);
  const [countStock, setCountStock] = useState([0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(1);
  const [mapPlaces, setMapPlaces] = useState({});

  const { skladName } = useSelector((store) => store.ui);
  const dispatch = useDispatch();

  const user = useSelector((store) => store.user);

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const onChangePage = (v) => {
    setPage(v);
  };
  const onChangeTab = (n) => {
    setTab(n);
  };

  const params = useMemo(() => {
    const providerId = parseInt(provider.id);

    return {
      search: search.trim(),
      limit: parseInt(limit),
      page,
      tab: isInventory ? FILTER_INVENTORY[tab] : FILTER[tab],
      address,
      skladName: skladName.short_name,
      ...(providerId && { providerId }),
    };
  }, [search, page, tab, limit, provider.id, address, isInventory, skladName?.short_name]);

  const searchProducts = async () => {
    await WarehouseCommonApi.getProductsBySearch({ data: params }).then((r) => {
      const { all, instock, nullstock, reserve, notmarker, matched, notMatched, notIp, old_products } = r.stock;
      setCount(r.stock.count);
      setCountStock(
        isInventory
          ? [all, instock, matched, notMatched, notIp]
          : [all, instock, nullstock, reserve, notmarker, notIp, old_products],
      );

      const byIds = {};
      const id = r.data.map((item) => item.id);
      // eslint-disable-next-line no-return-assign
      r.data.forEach((item) => (byIds[item.id] = item));

      setById(byIds);
      setIds(id);
      setMapPlaces(r.addresses);
    });
  };

  const onDelete = (id) => {
    WarehouseCommonApi.deleteOne({ data: { id } }).then(() => {
      setRemove({ open: false, id: null });
      searchProducts();
    });
  };

  useEffect(() => {
    searchProducts().then();
  }, [params]);

  useEffect(() => {
    const p = allProviders;
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '', id: null });
    }
  }, [allProviders]);
  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <Content>
      <Row spaceBetween={true}>
        <H1>Склад {skladName?.address}</H1>
      </Row>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={
              isInventory
                ? ['Все товары', 'На складе', 'Сошлось', 'Расхождения', 'Без ИП']
                : ['Все товары', 'На складе', 'Нет на складе', 'В резерве', 'Без места', 'Без ИП', 'Давно не в продаже']
            }
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>
        <Input
          value={search}
          onBlur={(v) => setSearch(v)}
          //ref={inputRef}
          onClickEnter={(v) => setSearch(v)}
          label="Поиск"
        />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row style={{ alignItems: 'flex-end' }}>
            <div>
              <Select
                label="Показать на странице"
                select={limit}
                list={['50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setLimit(v)}
                width="100px"
                style={{ marginRight: '10px' }}
              />
            </div>
            <div>
              <Select
                label="Город"
                select={skladName}
                list={SKLADS_WAREHOUSE.filter((item) => user.sklads[item.short_name])}
                valueFn={(p) => p.name}
                onSelect={(v) => dispatch(uiChangeSkladName(v))}
                width="200px"
                style={{ marginRight: '15px' }}
              />
            </div>

            <div>
              <Select
                label="Поставщик"
                select={provider}
                list={providers}
                valueFn={(p) => p.name}
                onSelect={(v) => changeProvider(v)}
                width="200px"
                style={{ marginRight: '15px' }}
              />
            </div>
            <Row>
              <Input
                value={address}
                label={'Адрес на складе'}
                showLabel={true}
                width={'100px'}
                placeholder={'Не выбрано'}
                onBlur={(v) => changeAddress(v)}
                style={{ marginRight: '15px' }}
              />
              <Button
                type={TYPE_BUTTONS.WHITE}
                disabled={!address}
                onClick={() =>
                  WarehouseCommonApi.excelWbBarcodes({
                    data: {
                      address,
                      skladName: skladName.short_name,
                    }
                  })
                }
                style={{ marginTop: '25px', marginRight: '35px' }}
              >
                Скачать fbo barcodes
              </Button>
            </Row>
            {isOwner && !isInventory && (
              <>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  style={{ marginLeft: '10px' }}
                  disabled={!provider.id || tab !== 1}
                  onClick={() => WarehouseCommonApi.addToKuper({ data: { providerId: provider.id, shop: 'kuper1' } })}
                >
                  Перенести в СберМаркет
                </Button>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  style={{ marginLeft: '10px' }}
                  disabled={!provider.id || tab !== 1}
                  onClick={() => WarehouseCommonApi.addToYandexExpress({ data: { providerId: provider.id, shop: 'yandex8' } })}
                >
                  Перенести в Яндекс
                </Button>
              </>
            )}
          </Row>

          <Column className={styles.column_button}>
            <Row style={{ alignItems: 'flex-end' }}>
              {isOwner && (
                <>
                  <Input value={numDays} onChange={(v) => setNumDays(v)} width={'50px'} center />
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() =>
                      WarehouseCommonApi.excelHistory({
                        data: {
                          search,
                          tab: FILTER[tab],
                          days: parseInt(numDays),
                          skladName: skladName.short_name,
                        }
                      })
                    }
                    style={{ marginRight: '15px' }}
                  >
                    Скачать историю
                  </Button>
                </>
              )}
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>
                  WarehouseCommonApi.excelData({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                    }
                  })
                }
                style={{ marginRight: '15px' }}
              >
                Скачать данные
              </Button>
            </Row>
          </Column>
        </Row>
      </WhiteBlock >
      <Table styles={styles.stocks_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={width[0]}>Фото</HeaderTitle>
          <HeaderTitle width={width[2]}>Артикул</HeaderTitle>
          <HeaderTitle width={width[9]}>Адрес на складе</HeaderTitle>
          <HeaderTitle width={width[1]}>Название</HeaderTitle>
          {(isInventory && tab === 4) ||
            (!isInventory && tab === 5 && (
              <HeaderTitle width={width[3]} centerText>
                Закупочное ИП
              </HeaderTitle>
            ))}
          {isInventory && (
            <HeaderTitle width={width[3]} centerText>
              Инвентаризация
            </HeaderTitle>
          )}

          <HeaderTitle width={width[3]} centerText>
            На складе
          </HeaderTitle>
          <HeaderTitle width={width[3]} centerText>
            Резерв
          </HeaderTitle>
          <HeaderTitle width={width[3]}>Поставщик</HeaderTitle>
          <HeaderTitle width={width[4]}>Штрихкод</HeaderTitle>
          <HeaderTitle width={width[4]} centerText>
            Размещение на площадках
          </HeaderTitle>
        </TableHeader>
        {ids.map((id) => {
          const item = byId[id];

          let inventoried = mapPlaces[item.address]?.inventoried || false;

          return (
            <ProductsTableLine
              item={item}
              isOwner={isOwner}
              setRemove={setRemove}
              width={width}
              key={id}
              isInventory={isInventory}
              tab={tab}
              skladName={skladName.short_name}
              inventoried={inventoried}
            />
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / limit) || 1} show={page} onChange={onChangePage} />
      {
        remove.open && (
          <DeleteProductPopUp
            id={remove.id}
            clickOk={(id) => onDelete(id)}
            close={() => setRemove({ open: false, id: null })}
          />
        )
      }
    </Content >
  );
}

export default WarehouseProductsPage;
